<template>
  <div class="report_item_wrapper" ref="alerts">
    <div class="report_header">
      <div class="item_title">
        <i class="iconfont">&#xe655;</i>
        <span>{{$t('title.onlinexinlv')}}</span>
      </div>
      <div class="item_warn" v-show="echartShows"></div>
    </div>
    <div class="echarts_wrapper" v-show="echartShows">
      <!-- 图表数据 -->
      <div class="echartTop">
        <span>{{$t('components.celiangTime')}}:{{time}}</span>
      </div>
      <div class="draw_echarts">
        <keep-alive>
          <div class="chart" ref="chart" :id="id"></div>
        </keep-alive>
      </div>
      <p class="chartTip">*{{$t('tag.shipin')}}</p>
      <div class="parameter">
        <ul>
          <li class="item">
            <span :class="['value',top.color]">
              <template v-if="top.rate!==''">
                <strong>{{top.rate}}</strong>
                <i>bpm</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.xinlv.zuigao')}}</p>
          </li>
          <li class="item">
            <span :class="['value',low.color]">
              <template v-if="low.rate!==''">
                <strong>{{low.rate}}</strong>
                <i>bpm</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.xinlv.zuidi')}}</p>
          </li>
          <li class="item">
            <span :class="['value',ave.color]">
              <template v-if="ave.rate!==''">
                <strong>{{ave.rate}}</strong>
                <i>bpm</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.xinlv.pingjun')}}</p>
          </li>
        </ul>
      </div>

      <!-- 健康报告 -->

      <div class="read part-top">
        <div class="header">
          <i class="iconfont">&#xe61d;</i>
          <h2>{{$t('title.secondaryTitle.xinlvOnlinepg')}}</h2>
        </div>
        <div class="content1">
          <div class="content1_1">
            <!--  v-for="(item,index) in content" :key="index" -->
            <p>{{content}}</p>
          </div>
        </div>
      </div>
      <!-- 参数解读 -->
      <div class="read part-top">
        <div class="header">
          <i class="iconfont">&#xe61d;</i>
          <h2>{{$t('tag.canshujiedu')}}</h2>
        </div>
        <div class="content">
          <h3>{{randomTitle.title}}</h3>
          <div :class="['article',contentShow ? 'show' : 'hidden']" v-html="randomTitle.content"></div>
          <div :class="['mask',contentShow ? 'show' : 'hidden']" @click="contentToggle">
            <i class="iconfont" v-show="!contentShow">&#xe632;</i>
            <i class="iconfont" v-show="contentShow">&#xe633;</i>
          </div>
        </div>
      </div>
    </div>
    <!-- 暂无数据 -->
    <div class="nodata" v-if="!echartShows">{{$t('tag.breathe.noweek')}}</div>
    <!-- 弹窗 -->
  </div>
</template>
<script>
export default {
  name: "onlineheart",
  props: {
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      reatedatas: {},
      datePickerShow: false,
      heartShow: true,
      regularDate: "",
      appType: {
        appName: this.$route.params.appName
      },
      wranTip: false,
      id: "online",
      xdata: [],
      ydata: [],
      visible: true,
      contentRandom: this.$t("tag.canshujieduContent.manualrate"),
      appType: {
        appName: this.$route.params.appName
      },
      contentShow: false,
      echartShows: true,
      low: "",
      top: "",
      ave: "",
      content: "",
      time: ""
    };
  },
  mounted() {
    this.getCurrentDataInfo();
    this.newdate();
  },
  methods: {
    dialogVisible() {
      this.datePickerShow = true;
    },
    newdate() {
      let dt = new Date();
      let y = dt.getFullYear();
      let m = dt.getMonth() + 1;
      let d = dt.getDate();
      m = m > 9 ? m : "0" + m;
      this.regularDate = y + "-" + m + "-" + d;
      // console.log(this.regularDate)
    },
    getCurrentDataInfo() {
      let postData = {
        date: this.regularDate,
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token,
        current: this.current
      };
      this.$axios
        .getOnlineHeartRate(this.appType, postData)
        .then(this.getCurrentDataInfoSucc);
    },
    getCurrentDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        this.heartShow = true;
        let datas = res.data.echarts;
        this.low = res.data.lowrate;
        this.top = res.data.toprate;
        this.ave = res.data.averate;
        this.time = res.data.starttime;
        for (let item of datas) {
          this.ydata.push(item.rate);
          this.xdata.push(item.time);
        }

        this.content =
          this.$t("manualrate.a") +
          this.ave.rate +
          this.$t("manualrate." + res.data.statec) +
          (res.data.statec === "zhengchang" ? "" : this.$t("manualrate.b"));

        this.init();
        this.setOption(this.options);
      } else if (res.code === 999) {
        this.heartShow = false;
      }
    },
    init() {
      let _this = this;
      this.chart = this.$echarts.init(
        document.getElementById(this.id),
        "light"
      );
      window.addEventListener("resize", function() {
        _this.chart && _this.chart.resize();
      });
    },
    setOption(option) {
      if (!this.chart) {
        return;
      }
      this.chart.setOption(option);
    },
    dispose() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },

    contentToggle() {
      this.contentShow = !this.contentShow;
    }
  },
  computed: {
    options() {
      return {
        series: {
          type: "line",
          max: 180,
          sampling: "average",
          data: this.ydata
        },
        color: "#3696ea",
        grid: {
          containLabel: true,
          top: 20,
          bottom: 10,
          left: 0,
          right: 0
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            let val = Number(params[0].value);
            let time = params[0].axisValue;
            let res = ` ${time}<br/> ${val} bpm`;
            return res;
          }
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#54657e",
              width: 1
            }
          },
          data: this.xdata
        },
        yAxis: {
          type: "value",
          min: 0,
          interval: 20,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cad3df",
              width: 1
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }
      };
    },
    randomTitle() {
      return this.contentRandom[
        Math.round(Math.random() * (this.contentRandom.length - 1))
      ];
    }
  },
  components: {
    // "heart-rate": heartRate
  },
  watch: {
    regularDate: function() {
      this.getCurrentDataInfo();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/global.styl';

.echartTop {
  font-size: 0.26rem;
  margin-top: 0.3rem;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/online-heartRate/onlineheart.vue